/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, FieldProps, TextField } from 'framework/ui/field';

const PaidLeaveBalanceField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const displayedValue = `${getValue()} working days`;

  return <TextField {...props} value={displayedValue} />;
};

export default PaidLeaveBalanceField;
